import {Text} from 'platform/foundation';

import {PurchasePriceRuleScope} from '@dms/api/sales';
import {i18n} from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {usePurchasePriceRuleScopeLabels} from '../../../../../hooks/usePurchasePriceRuleScopeLabels';
import {formatPurchasePriceRuleScope} from '../../../../../utils/formatPurchasePriceRuleScope';

interface PurchasePriceRuleScopeLineProps extends TestIdProps {
  scope: PurchasePriceRuleScope;
}

export function PurchasePriceRuleScopeLine(props: PurchasePriceRuleScopeLineProps) {
  const getLabel = usePurchasePriceRuleScopeLabels(props.scope);

  return (
    <Text size="small" color="secondary" overflowWrap="anywhere" data-testid={props['data-testid']}>
      {formatPurchasePriceRuleScope({
        scope: props.scope,
        getLabel,
        allModelFamiliesLabel: i18n.t(
          'page.settings.purchasePrice.marginRules.scope.allModelFamilies'
        ),
        allTrimsLabel: i18n.t('page.settings.purchasePrice.marginRules.scope.allTrims'),
      })}
    </Text>
  );
}
